import * as actionTypes from 'modules/audits/actionTypes';
import { createReducer } from 'utils/ReduxUtils';

const initialState = false;

const load = () => true;

const reset = () => initialState;

export default createReducer(initialState, {
  [actionTypes.FETCH_FO_URL]: load,
  [actionTypes.FETCH_FO_URL_SUCCESS]: reset,
  [actionTypes.FETCH_FO_URL_FAILURE]: reset,
});
